<template>
  <div class="panel">
    <div class="panel-heading">
      <h4 class="panel-title">话题</h4>
      <span class="pull-right" v-if="right__topic_create && hasCreateTopicPermission">
        <a @click="handleTopic('create')">
          <i class="iconfont icon-send"></i>
          创建话题
        </a>
      </span>
    </div>
    <div class="panel-body">
      <div class="dynamicwrap">
        <div
          class="dynamic"
          v-for="(topic, topic_index) in groupTopic"
          :key="topic.topic_number"
        >
          <div class="dynamic-list">
            <div class="header" @click="goToUser(topic.topic_creater_number)">
              <div class="user-avator">
                <img :src="topic.topic_creater_avatar" />
              </div>
            </div>
            <div class="comment">
              <div class="name">
                <h1>
                  <b @click="goToUser(topic.topic_creater_number)">{{
                    topic.topic_creater_name
                  }}</b>
                  <span>
                    {{ topic.topic_title }}
                    <a
                      v-if="
                        right__topic_edit && (hasEditOtherTopicPermission ||
                        (isMember &&
                          userInfo.user_number === topic.topic_creater_number &&
                          hasEditSelfTopicPermission))
                      "
                      title="编辑话题"
                      @click="handleTopic('update', topic)"
                    >
                      <i class="iconfont icon-send"></i>
                    </a>
                  </span>
                </h1>
              </div>
              <div class="cont" v-html="topic.topic_content"></div>
              <div class="btnbox" v-if="isMember">
                <span v-if="right__topic_comment_create && hasCreateCommentPermission">
                  <a @click="handleReview(topic)">
                    <i class="iconfont icon-review"></i>
                    回复
                  </a>
                </span>
                <span
                  v-if="
                    right__topic_delete && (hasDeleteOtherTopicPermission ||
                    (isMember &&
                      userInfo.user_number === topic.topic_creater_number &&
                      hasDeleteSelfTopicPermission))
                  "
                >
                  <a @click="deleteTopic(topic, topic_index)">
                    <i class="iconfont icon-trash"></i>
                    删除
                  </a>
                </span>
                <span v-if="right__topic_report_create">
                  <a @click="handleReport(topic, 'topic')">
                    <i class="iconfont icon-jvbao"></i>
                    举报
                  </a>
                </span>
              </div>
            </div>
            <div
              class="time"
              v-if="topic.topic_created_date === topic.topic_updated_date"
            >
              {{ topic.topic_created_date }}
            </div>
            <div class="time" v-else>
              {{ topic.topic_last_editer_name }} 在
              {{ topic.topic_updated_date }} 编辑了该话题
            </div>
          </div>
          <div
            class="review-wrap"
            v-show="
              groupComment[topic_index] && groupComment[topic_index].length
            "
          >
            <div
              class="review-list"
              v-for="(comment, comment_index) in groupComment[topic_index]"
              :key="comment.topic_comment_number"
            >
              <div class="comment">
                <div class="cont">
                  <b @click="goToUser(comment.topic_commenter_number)">{{
                    comment.topic_commenter_name
                  }}</b>
                  <p v-html="comment.topic_comment_content"></p>
                </div>
                <div class="btnbox" v-if="isMember">
                  <span v-if="right__topic_comment_create && hasCreateCommentPermission">
                    <a @click="handleReview(topic, comment)">
                      <i class="iconfont icon-review"></i>
                      回复
                    </a>
                  </span>
                  <span
                    v-if="
                     right__topic_comment_delete && (hasDeleteOtherCommentPermission ||
                      (userInfo.user_number ===
                        comment.topic_commenter_number &&
                        hasDeleteSelfCommentPermission))
                    "
                  >
                    <a
                      @click="
                        deleteComment(
                          topic,
                          topic_index,
                          comment,
                          comment_index
                        )
                      "
                    >
                      <i class="iconfont icon-trash"></i>
                      删除
                    </a>
                  </span>
                  <span v-if="right__topic_report_create">
                    <a @click="handleReport(comment, 'topic_comment')">
                      <i class="iconfont icon-jvbao"></i>
                      举报
                    </a>
                  </span>
                </div>
              </div>
              <div class="time">{{ comment.topic_comment_created_date }}</div>
            </div>
          </div>
        </div>
        <div class="nofile" v-if="!groupTopic.length">
          <div class="pic">
            <img src="@/assets/images/notopic.svg" />
          </div>
          <h4>{{ noTopic.title }}</h4>
          <p>{{ noTopic.reason }}</p>
          <div class="nobtn" v-if="right__topic_create && hasCreateTopicPermission">
            <button
              class="btn btn-default"
              type="button"
              @click="handleTopic('create')"
            >
              <i class="ti-comments"></i>
              创建话题
            </button>
          </div>
        </div>
      </div>
    </div>

    <GroupTopicCreate
      :group_number="groupNumber"
      :dialogStatus="dialogStatus"
      :temp="temp"
      @refreshTopic="refreshTopic"
      v-if="status.GroupTopicCreateStatus"
    ></GroupTopicCreate>
    <GroupReview
      :comment="comment"
      @refreshTopic="refreshTopic"
      v-if="status.GroupReviewStatus"
    ></GroupReview>
    <GroupReport :report="report" v-if="status.GroupReportStatus"></GroupReport>
  </div>
</template>

<script>
import {
  getTopic,
  deleteTopic,
  getComment,
  deleteComment,
} from "@/api/topic/topic";
export default {
  name: "GroupTopic",
  components: {
    GroupTopicCreate: () => import("./GroupTopicCreate"),
    GroupReview: () => import("./GroupReview"),
    GroupReport: () => import("./GroupReport"),
  },
  data() {
    return {
      noTopic: {
        title: "还没有话题",
        reason: "创建话题，与大家一起讨论吧。",
      },
      status: {
        GroupTopicCreateStatus: false,
        GroupReviewStatus: false,
        GroupReportStatus: false,
        GroupApplyStatus: false,
      },
      dialogStatus: "create",
      temp: {},
      groupTopic: [],
      groupComment: [],
      comment: {
        topicNumber: null,
        commentNumber: null,
        commentToName: null,
      },
      report: {
        report_object_number: null,
        report_object_type: null,
        name: null,
      },
    };
  },
  created() {
    this.groupNumber = this.$route.params.groupNumber;
  },
  computed: {
    right__topic_report_create () {
      return this.$store.getters.right__topic_report_create
    },
    right__topic_comment_create () {
      return this.$store.getters.right__topic_comment_create
    },
    right__topic_comment_delete () {
      return this.$store.getters.right__topic_comment_delete
    },
    right__topic_delete () {
      return this.$store.getters.right__topic_delete
    },
    right__topic_edit () {
      return this.$store.getters.right__topic_edit
    },
    right__topic_create () {
      return this.$store.getters.right__topic_create
    },
    group() {
      return this.$store.state.drive.group;
    },
    isMember() {
      return this.$store.state.group.isMember;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    // 查看所有话题
    hasViewAllTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("viewAllTopic") > -1
      );
    },
    // 查看所有评论
    hasViewAllCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("viewAllComment") > -1
      );
    },
    // 创建话题
    hasCreateTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("createTopic") > -1
      );
    },
    // 编辑TA人话题
    hasEditOtherTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("editOtherTopic") > -1
      );
    },
    // 编辑自己话题
    hasEditSelfTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("editSelfTopic") > -1
      );
    },
    // 删除TA人话题
    hasDeleteOtherTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("deleteOtherTopic") > -1
      );
    },
    // 删除自己话题
    hasDeleteSelfTopicPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("deleteSelfTopic") > -1
      );
    },
    // 创建评论
    hasCreateCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("createComment") > -1
      );
    },
    // 编辑TA人评论
    hasEditOtherCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("editOtherComment") > -1
      );
    },
    // 编辑自己评论
    hasEditSelfCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("editSelfComment") > -1
      );
    },
    // 删除TA人评论
    hasDeleteOtherCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("deleteOtherComment") > -1
      );
    },
    // 删除自己评论
    hasDeleteSelfCommentPermission() {
      return (
        (this.group && this.group.group_member_identity === "owner") ||
        this.permissions.public_operations.indexOf("deleteSelfComment") > -1
      );
    },
  },
  methods: {
    /**
     * 跳转到用户
     */
    goToUser(userNumber) {
      let routeUrl = this.$router.resolve({
        name: "user",
        params: { userNumber: userNumber },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 删除评论
    deleteComment(topic, topic_index, comment, comment_index) {
      deleteComment({
        topic_comments_list: [comment.topic_comment_number],
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.groupComment[topic_index].splice(comment_index, 1);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
            if (res.status_code === 410) {
              this.getTopic();
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 删除话题
    deleteTopic(topic, index) {
      this.$confirm({
        type: "confirm",
        content: "删除话题后，其所有的评论都将被删除且不可恢复，确定删除吗？",
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          deleteTopic({
            topics_list: [topic.topic_number],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.getTopic();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
                if (res.status_code === 410) {
                  this.getTopic();
                }
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    // 显示举报
    handleReport(params, type) {
      if (type === "topic") {
        this.report.report_object_number = params.topic_number;
        this.report.name = params.topic_creater_name;
      } else if (type === "topic_comment") {
        this.report.report_object_number = params.topic_comment_number;
        this.report.name = params.topic_commenter_name;
      }
      this.report.report_object_type = type;
      $("#report").modal("show");
    },
    // 显示回复
    handleReview(topic, comment = null) {
      this.comment.topicNumber = topic.topic_number;
      this.comment.commentNumber = comment
        ? comment.topic_commenter_number
        : null;
      this.comment.commentToName = comment
        ? comment.topic_commenter_name
        : null;
      $("#review").modal("show");
    },
    // 显示编辑话题
    handleTopic(action, topic) {
      this.dialogStatus = action;
      if (topic) {
        this.temp = topic;
      } else {
        this.temp = {};
      }
      $("#newtopic").modal("show");
    },
    // 刷新话题列表
    refreshTopic() {
      this.getTopic();
    },
    // 获取话题列表
    getTopic() {
      if (!this.hasViewAllTopicPermission) {
        this.noTopic = {
          title: "没有权限查看话题",
          reason: "如需查看话题，请联系群主/管理员。",
        };
        return false;
      }
      getTopic({
        topic_object_number: this.groupNumber,
        topic_object_type: "group",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.groupTopic = res.entity.datas;
            this.groupComment = [];
            if (this.hasViewAllCommentPermission) {
              this.groupTopic.map((topic, index) => {
                this.getComment(topic, index);
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取评论并将其插入到对应话题中
    getComment(topic, index) {
      getComment({
        topic_number: topic.topic_number,
      })
        .then((resc) => {
          let comments = resc.entity.datas.sort((x, y) => {
            return x.topic_comment_number - y.topic_comment_number;
          });
          if (comments.length) {
            this.$set(this.groupComment, index, comments);
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    this.getTopic();
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 500);
  },
};
</script>

<style scoped>
</style>